import React, { useEffect, useRef } from "react";
import {
  FullWidthImage,
  ImageContainer,
  Paragraph,
  ParagraphContainer,
} from "../styles/components/body";
import { Marquee } from "./marquee";
import animations from "../animations/animations";

const BodyContentComponent = ({ articleData, bodyItems, parentWrapperRef }) => {
  const paragraphRefs = useRef([]);

  useEffect(() => {
    if (!paragraphRefs.current || typeof window === "undefined") return;

    setTimeout(() => {
      paragraphRefs.current.forEach(ref => {
        if (ref) animations.parallax(ref, 10);
      });
    }, 1000);
  }, []);

  return (
    <>
      {bodyItems &&
        bodyItems?.map((component, i) => {
          switch (component.__typename) {
            case "DatoCmsParagraph":
              return (
                <ParagraphContainer
                  key={i}
                  ref={el => (paragraphRefs.current[i] = el)}
                >
                  <Paragraph
                    $primaryColor={articleData?.colors?.primary}
                    $secondaryColor={articleData?.colors?.secondary}
                    suppressHydrationWarning={true}
                    dangerouslySetInnerHTML={{
                      __html: component.text,
                    }}
                  />
                </ParagraphContainer>
              );
            case "DatoCmsMarquee":
              const desktopImages = component?.images?.slice(0, 2) || [];
              const mobileImages = component?.images?.slice(2, 4) || [];

              return (
                <React.Fragment key={`marquee-wrapper-${i}`}>
                  <Marquee
                    key={`${i}-desktop`}
                    marqueeId={`${i}-desktop`}
                    parentWrapperRef={parentWrapperRef}
                    images={desktopImages}
                    desktopHeight={component.desktopHeight}
                    mobileHeight={0}
                    direction={component.direction}
                    marqueeDuration={component.marqueeDuration}
                    triggerScrub={component.triggerScrub}
                    articleId={articleData?.id}
                    isDesktop={mobileImages.length !== 0}
                  />
                  {mobileImages.length > 0 && (
                    <Marquee
                      key={`${i}-mobile`}
                      marqueeId={`${i}-mobile`}
                      parentWrapperRef={parentWrapperRef}
                      images={mobileImages}
                      desktopHeight={0}
                      mobileHeight={component.mobileHeight}
                      direction={component.direction}
                      marqueeDuration={component.marqueeDuration}
                      triggerScrub={component.triggerScrub}
                      articleId={articleData?.id}
                      isMobile={true}
                    />
                  )}
                </React.Fragment>
              );
            case "DatoCmsImage":
              return (
                <ImageContainer key={i} $bodyImage>
                  {component.images?.map((item, i) => (
                    <React.Fragment key={i}>
                      {item.image && (
                        <FullWidthImage
                          key={`desktop-${i}`}
                          src={item.image?.fluid?.src}
                          alt={item.image?.alt || "image"}
                          $desktop
                        />
                      )}

                      {item.imageMobile && (
                        <FullWidthImage
                          key={`mobile-${i}`}
                          src={item.imageMobile?.fluid?.src}
                          alt={item.imageMobile?.alt || "image"}
                          $mobile
                        />
                      )}
                    </React.Fragment>
                  ))}
                </ImageContainer>
              );
            default:
              return null;
          }
        })}
    </>
  );
};

export default BodyContentComponent;
